import { render, staticRenderFns } from "./camera.vue?vue&type=template&id=a0cfb03c&scoped=true"
import script from "./camera.vue?vue&type=script&lang=js"
export * from "./camera.vue?vue&type=script&lang=js"
import style0 from "./camera.vue?vue&type=style&index=0&id=a0cfb03c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0cfb03c",
  null
  
)

export default component.exports